


































































import { Component } from 'vue-property-decorator'
import BaseDialog from '@/utils/dialog-control'
import $Api from '@api'
import { translate } from '@/utils/filters'
import { Bank, Merchant, PayType } from '@/api/model/channel'

@Component
export default class BankDialog extends BaseDialog {
    form = {
        bankName: '',
        merchantId: '',
        icon: '',
        phone: '',
        website: '',
        prompt: '',
        payType: '',
        status: '',
        id: '',
        bankId: ''
    }
    rules = {
        merchantId: { required: true, message: translate('bank.merchantNoNull'), trigger: 'change' },
        bankName: { required: true, message: translate('bank.NoNull'), trigger: 'change' },
        status: { required: true, message: translate('status.NameNoNull'), trigger: 'change' }
    }

    payTypes: PayType[] = []
    merchants: Merchant[] = []
    banks: Bank[] = []
    bank = {} as Bank

    change(e: any) {
        console.log(e)
    }

    async querySearch(queryString: string, cb: Function) {
        queryString += ''
        let results = queryString ? this.banks.filter(this.createFilter(queryString)) : this.banks
        cb(results)
    }

    createFilter(queryString: string) {
        return (restaurant: Bank) => {
            return (restaurant.bankName.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        }
    }

    async handleSelect(bank: any) {
        this.bank = bank
        $Api.channelService.queryAbroadBankById(bank.id).subscribe(bankDetail => {
            Object.keys(this.form)
                .filter(key => (key !== 'id' && key !== 'merchantId' && bankDetail[key] !== undefined))
                .map(key => {
                    this.form[key] = bankDetail[key]
                })
        })
    }

    public update() {
        return $Api.channelService.bankMerchantUpdate({
            bankId: this.bank.id || this.form.bankId,
            id: this.form.id,
            bankName: this.bank.bankName,
            status: this.form.status,
            merchantId: this.form.merchantId,
            prompt: this.form.prompt
        })
    }

    public create() {
        return $Api.channelService.bankMerchantAdd({
            bankId: this.bank.id,
            bankName: this.bank.bankName,
            status: this.form.status,
            merchantId: this.form.merchantId,
            prompt: this.form.prompt
        })
    }

    public onOpen() {
        this.loadData()
    }

    onClose() {
        this.form.id = ''
        this.form.bankId = ''
        this.bank = {} as Bank
    }

    private async loadData() {
        $Api.channelService.queryMerchantDropdownByUser().subscribe(data => {
            this.merchants = data
        })
        $Api.channelService.queryAbroadBankDropdown().subscribe(data => {
            this.banks = data
        })
        $Api.channelService.queryPayTypeList().subscribe(data => {
            this.payTypes = data
        })
    }
}
